export default __webpack_public_path__ + "static/site-logo-dark-61e2cf2873a3ada441f8c4f128e99168.png";